export default __webpack_public_path__ + "media/zurb/img/about/bryan/youtube-icon-f1061ca0d18899ef0650dad24da37cc3.svg";